import { Group } from "@fairfleet/geotab";
import Box from "@mui/material/Box";
import { HTMLAttributes, useMemo } from "react";
import { AUDIT_TOKENS } from "../../theme/auditTokens";
import { groupParentHints } from "../../utils/groupHierarchy";
import { buildGroupIndex } from "@/utilities/groupIndex";

/**
 * Option renderer for the group pickers. MUI keys options by their label, and Geotab allows
 * several groups with the same name; duplicate keys make React keep stale options when the
 * list is filtered. The key is the group id, and groups with a shared name show their parent.
 */
export function useGroupOptionRenderer(groups: Group[]) {
  const hints = useMemo(() => groupParentHints(groups, buildGroupIndex(groups)), [groups]);
  return (props: HTMLAttributes<HTMLLIElement> & { key?: string }, option: Group) => {
    const { key: _key, ...rest } = props;
    const hint = hints.get(option.id);
    return (
      <Box component="li" {...rest} key={option.id} sx={{ display: "flex", gap: 1, alignItems: "baseline" }}>
        <span>{option.name}</span>
        {hint !== undefined && (
          <Box component="span" sx={{ fontSize: 12, color: AUDIT_TOKENS.muted, overflow: "hidden", textOverflow: "ellipsis" }}>
            {hint}
          </Box>
        )}
      </Box>
    );
  };
}
